
import * as React from 'react';
import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { Grid, InputLabel, Typography } from '@mui/material';
import { IFormController } from '../types';
import { el } from 'react-date-range/src/locale/index';

function FormTimePicker(props: IFormController) {
  const { label, name, required, formik, customLabel, filtersDesign, ...rest } = props;

  const [value, setValue] = React.useState(formik?.values[name]);

  React.useEffect(() => {
    setValue(formik?.values[name]);
  }, [formik?.values[name]]);

  return (
    <Grid>
      {customLabel
        ? <InputLabel
          htmlFor={name}
          sx={{
            textAlign: 'left',
            textStyle: 'none',
            my: 2
          }}
        >
          <Typography
            variant='body1'
            sx={{ fontWeight: '500' }}>
            {label}
          </Typography>
        </InputLabel>
        : null
      }
      <LocalizationProvider
        locale={el} 
        dateAdapter={AdapterDayjs}>
        <TimePicker
          label={
            customLabel
              ? null
              : label
          }
          inputFormat='HH:mm'
          PopperProps={{
            disablePortal: true
          }}
          value={value
            ? value
            : formik?.getFieldProps(`${name}`).value
              ? formik?.getFieldProps(`${name}`).value
              : null}
          onChange={(newValue: any) => {
            setValue(newValue);
            formik?.setFieldValue(`${name}`, newValue);
          }}
          renderInput={(params: any) => <TextField
            required={required}
            sx={{
              minWidth: 200,
              width: '100%',
              ...(filtersDesign && {
                '& .MuiOutlinedInput-root': {
                  '& > fieldset': {
                    borderRadius: '24px'
                  }
                }
              })
            }}
            {...params} 
            inputProps={{
              ...params.inputProps,
              placeholder: 'ΩΩ/ΛΛ'
            }} 
          />}
          {...rest}
        />
      </LocalizationProvider>
    </Grid>
  );
}

export default FormTimePicker;